import { Component } from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import * as faIcons from '@fortawesome/free-solid-svg-icons';
import {PaneBackButtonComponent} from "../pane-back-button/pane-back-button.component";
import {Store} from "@ngrx/store";
import {User} from "../../auth/primitives/user";

import * as AuthSelectors from '../../state/auth/auth.selector';
import {authActions} from "../../state/auth/auth.actions";
import {ProfileImageComponent} from "../profile-image/profile-image.component";

@Component({
  selector: 'profile',
  standalone: true,
  imports: [
    FontAwesomeModule,
    PaneBackButtonComponent,
    ProfileImageComponent
  ],
  templateUrl: './profile.component.html',
  styleUrl: './profile.component.scss'
})
export class ProfileComponent {

  user: User = null

  constructor(
      private store: Store,
      private router: Router,
      private route: ActivatedRoute
  ) {
    this.store.select(AuthSelectors.selectUser).subscribe((user) => {
      this.user = user
    })
  }

  editProfile() {
    this.router.navigate([{outlets: {'right-pane': "profile-edit"}}])
  }

  logout() {
    this.store.dispatch(authActions.logoutUser())
  }

  protected readonly faIcons = faIcons;
}
